export default {
    tabs: {
        slices: 'الشرائح الوظيفية',
        levels: 'المستويات الوظيفية',
        recompenses: 'البدلات',
        deductions: 'الاقتطاعات',
        equations: 'معادلات الراتب',
    },
    slice: 'شريحة وظيفية',
    level: 'مستوى وظيفي',
    recompense: 'بدل',
    deduction: 'اقتطاع',
    equation: 'معادلة راتب',
    
    'the-slice': 'الشريحة الوظيفية',
    'the-level': 'المستوى الوظيفي',
    'the-recompense': 'البدل',
    'the-deduction': 'الاقتطاع',
}